import * as Html from "../../util/Html.ts";
import * as Storage from "../../lib/Storage.ts";
import Icons from "../../svg/Icons.ts";
export {init}
Html.registerWidget('widget/form/rememberme',{init:init})
  
function init(elem){
  elem.css('cursor','pointer');
  var isChecked = false;
    
  elem.on('click',function(){
    isChecked = !isChecked;
    elem.html(isChecked?Icons.ic_checked.toString():Icons.ic_checkbox.toString());
    Storage.localSet('rememberme',isChecked);
  })
}